<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Forget Password" | translate }}</h3>
    <p>
      {{
        "Enter your email to send OTP code to reset your password" | translate
      }}
    </p>
    <label>{{ "Email" | translate }}</label>
    <div class="input-container mt-1">
      <i class="bi bi-envelope left-icon"></i>
      <input type="text" [(ngModel)]="email" placeholder="{{ 'Enter your email' | translate }}" />
    </div>

    <button (click)="forgetPassowrd()" class="w-100 gradient-button">
      {{ "Send OTP Code" | translate }}
    </button>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" routerLink="/login">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 pt-5 right-container">
    <img width="20%" src="../../../../assets/img/logo.png" />
    <br />
    <img width="80%" class="mt-3" src="../../../../assets/img/authGroup.svg" />
  </div>
</div>
